import URI from 'urijs';
import { saveAs } from 'file-saver';
import { wrapFunc, AesEncrypt } from '../../util/js';
import { CB_STATUS, cFetch } from '../../util/fetch';
import { SELECT_SIZE, PATH_API_ACCOUNT } from '../../config';
import { errCB } from './auth';
import { getDomain } from '../../util/url';

export const actGetAccounts = wrapFunc((dispatch, data, cb) => {
  dispatch({
    type: 'ACCOUNT_GET_DOING',
  });
  const urlQuery = {
    limit: SELECT_SIZE,
    offset: data.offset,
  };
  const url = URI(getDomain() + PATH_API_ACCOUNT)
    .query(urlQuery)
    .toString();
  return cFetch(url, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${data.token}`,
      'Accept-Language': data.lang || 'en',
    },
    credentials: 'same-origin',
  })
    .then((j) => {
      if (j.status === 200) {
        const t = j.payload.results.map((v, i) => ({
          id: i,
          AccountName: v.Name,
          DisplayName: v.DisplayName,
          Password: v.Password,
          Device_Type: v.Device_Type,
          Device_Key: v.Device_Key,
          AssociatedDevice: v.AssociatedDevice.SerialNumber,
          DeviceDisplayName: v.AssociatedDevice.DisplayName,
        }));
        dispatch({
          type: 'ACCOUNT_GET_DONE',
          payload: {
            count: j.payload.count,
            results: t,
          },
        });
        if (cb) cb({ status: CB_STATUS.SUCCESS });
      } else {
        throw j;
      }
      return j;
    })
    .catch((err) => {
      dispatch({
        type: 'ACCOUNT_GET_ERR',
      });
      errCB(err, dispatch, cb);
    });
}, 'actGetAccounts');

export const actCreateAccount = wrapFunc((dispatch, data, cb) => {
  dispatch({
    type: 'ACCOUNT_CREATE_DOING',
  });

  const url = getDomain() + PATH_API_ACCOUNT;
  const formData = new FormData();
  // formData.append('DisplayName', data.DisplayName);
  // formData.append('SerialNumber', data.SerialNumber);

  formData.append('DisplayName', AesEncrypt(data.DisplayName));
  formData.append('SerialNumber', AesEncrypt(data.SerialNumber));
  return cFetch(url, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${data.token}`,
      'Accept-Language': data.lang || 'en',
    },
    body: formData,
    credentials: 'same-origin',
  })
    .then((j) => {
      if (j.status === 201) {
        const t = {
          AccountName: j.payload.Name,
          DisplayName: j.payload.DisplayName,
          Password: j.payload.Password,
          Device_Type: j.payload.Device_Type,
          Device_Key: j.payload.Device_Key,
          AssociatedDevice: j.payload.AssociatedDevice.SerialNumber,
          DeviceDisplayName: j.payload.AssociatedDevice.DisplayName,
        };
        dispatch({
          type: 'ACCOUNT_CREATE_DONE',
          payload: t,
        });
        if (cb) cb({ status: 'SUCCESS', payload: t });
      } else {
        throw j;
      }
      return j;
    })
    .catch((err) => {
      dispatch({
        type: 'ACCOUNT_CREATE_ERR',
      });

      switch (err.status) {
        case 400:
          if (err.payload !== undefined) {
            switch (err.payload[0]) {
              case 'Limit exceeded':
                if (cb) cb({ status: CB_STATUS.MAXLIMITAcc });
                break;
              default:
                break;
            }
            break;
          } else {
            if (cb) cb({ status: CB_STATUS.OTHER });
            break;
          }
        default:
          errCB(err, dispatch, cb);
      }
    });
}, 'actCreateAccount');

export const actUpdateAccount = wrapFunc((dispatch, data, cb) => {
  dispatch({
    type: 'ACCOUNT_UPDATE_DOING',
  });
  const suPath = 'editDisplayNamePassword';
  const url = `${getDomain() + PATH_API_ACCOUNT + suPath}/`;
  const formData = new FormData();
  // formData.append('DisplayName', data.DisplayName);
  // formData.append('Password', data.Password);
  formData.append('DisplayName', AesEncrypt(data.DisplayName));
  formData.append('Password', AesEncrypt(data.Password));
  formData.append('Name', AesEncrypt(data.Name));
  return cFetch(url, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${data.token}`,
      'Accept-Language': data.lang || 'en',
    },
    body: formData,
    credentials: 'same-origin',
  })
    .then((j) => {
      if (j.status === 200) {
        dispatch({
          type: 'ACCOUNT_UPDATE_DONE',
        });
        if (cb) cb({ status: CB_STATUS.SUCCESS });
      } else {
        throw j;
      }
      return j;
    })
    .catch((err) => {
      dispatch({
        type: 'ACCOUNT_UPDATE_ERR',
      });
      errCB(err, dispatch, cb);
    });
}, 'actUpdateAccount');

export const actDeleteAccount = wrapFunc((dispatch, data, cb) => {
  dispatch({
    type: 'ACCOUNT_DELETE_DOING',
  });
  const url = `${getDomain() + PATH_API_ACCOUNT + AesEncrypt(data.Name)}/`;

  return cFetch(url, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${data.token}`,
      'Accept-Language': data.lang || 'en',
    },
    credentials: 'same-origin',
  })
    .then((j) => {
      if (j.status === 204) {
        dispatch({
          type: 'ACCOUNT_DELETE_DONE',
        });
        if (cb) cb({ status: CB_STATUS.SUCCESS });
      } else {
        throw j;
      }
      return j;
    })
    .catch((err) => {
      dispatch({
        type: 'ACCOUNT_DELETE_ERR',
      });
      errCB(err, dispatch, cb);
    });
}, 'actDeleteAccount');

export const actDownloadAccount = wrapFunc((dispatch, data, cb) => {
  dispatch({
    type: 'ACCOUNT_DOWNLOAD_DOING',
  });
  const urlQuery = {
    Device__SerialNumber: AesEncrypt(data.SerialNumber),
  };
  const url = URI(getDomain() + PATH_API_ACCOUNT)
    .query(urlQuery)
    .toString();
  return fetch(url, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${data.token}`,
      'Accept-Language': data.lang || 'en',
      Accept: 'text/csv',
    },
    credentials: 'same-origin',
  })
    .then((r) => {
      dispatch({
        type: 'ACCOUNT_DOWNLOAD_DONE',
      });
      const disposition = r.headers.get('content-disposition');
      if (r.status === 200) {
        if (disposition && disposition.match(/attachment/)) {
          let filename = disposition.replace(/attachment;.*filename=/, '').replace(/"/g, '');
          filename = filename && filename !== '' ? filename : 'file';
          r.blob().then((blob) => {
            saveAs(blob, filename);
          });
        }
      } else {
        throw r;
      }
      return r;
    })
    .catch((err) => {
      dispatch({
        type: 'ACCOUNT_DOWNLOAD_ERR',
      });
      errCB(err, dispatch, cb);
    });
}, 'actDownloadAccount');
